import { useEffect, useState } from "react";
import { UserRound } from "lucide-react";

export type ProfileAvatarSize = "xs" | "sm" | "md" | "lg" | "xl";
export type ProfileAvatarShape = "circle" | "rounded";

const SIZE_CLASS: Record<ProfileAvatarSize,string> = {
  xs:"h-8 w-8 text-[10px]",
  sm:"h-10 w-10 text-xs",
  md:"h-12 w-12 text-sm",
  lg:"h-14 w-14 text-sm",
  xl:"h-16 w-16 text-base",
};

export function ProfileAvatar({
  src,name,size="md",shape="circle",className="",ring=false,alt
}:{
  src?:string|null;
  name:string;
  size?:ProfileAvatarSize;
  shape?:ProfileAvatarShape;
  className?:string;
  ring?:boolean;
  alt?:string;
}){
  const [failed,setFailed]=useState(false);
  useEffect(()=>setFailed(false),[src]);
  const shapeClass=shape==="circle"?"rounded-full":"rounded-2xl";
  const base=`${SIZE_CLASS[size]} ${shapeClass} shrink-0 overflow-hidden ${ring?"ring-2 ring-teal":"ring-1 ring-white/10"} ${className}`;
  if(src&&!failed){
    return <img src={src} alt={alt??`Foto de ${name}`} onError={()=>setFailed(true)} className={`${base} bg-white/[.04] object-cover`}/>;
  }
  const initials=name.trim().split(/\s+/).filter(Boolean).slice(0,2).map(x=>x[0]?.toUpperCase()).join("");
  return <span role="img" aria-label={alt??`Sem foto cadastrada para ${name}`} className={`${base} grid place-items-center bg-teal/[.09] font-black text-teal-light`}>
    {initials||<UserRound className="h-1/2 w-1/2"/>}
  </span>;
}
